export function load(state) {
    if (!state.data || !state.data.features) {
        return Promise.resolve().then(() => Promise.reject("no data"));
    }
    return Promise.resolve(state.data);
}
